export default __webpack_public_path__ + "static/media/ja3_thumb.da73c30d.jpg";